import React, { useEffect, useState } from "react";
import Topbar from "./Navigations/Topbar";
import MainBanner from "./MainBanner";
import NavbarWithCat from "./Navigations/NavbarWithCat";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import MobileHeader from "../MobileHeader";
import Footer from "../Footer";
import { getCartProductsByCustomerId } from "../../service/CartService";
import { getWishlistProductsByCustomerId } from "../../service/WishlistService";
import { useSelector } from "react-redux";

const CustomPrevArrow = (props) => {
  const { onClick } = props;
  return (
    <button
      className="custom-arrow prev-arrow"
      onClick={onClick}
    >
      <FaChevronLeft />
    </button>
  );
};

const CustomNextArrow = (props) => {
  const { onClick } = props;
  return (
    <button
      className="custom-arrow next-arrow"
      onClick={onClick}
    >
      <FaChevronRight />
    </button>
  );
};


const AboutPage = () => {
  const [cart, setCart] = useState([]);
  const [wishlist, setWishlist] = useState([]);
  const authUser = useSelector((state) => state.auth.authUser);

  const fetchData = async () => {
    const cartData = await getCartProductsByCustomerId(authUser.id);
    const response = await getWishlistProductsByCustomerId(authUser.id);
    setCart(cartData)
    setWishlist(response);
  }

  useEffect(() => {
    fetchData();
  }, [])

  const settings = {
    infinite: true,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    autoplay: false,
    // prevArrow: <div className="d-inline-block" ><CustomPrevArrow /></div>,
    // nextArrow: <div className="d-inline-block"><CustomNextArrow /></div>,
    responsive: [
      { breakpoint: 991, settings: { slidesToShow: 2 } },
      { breakpoint: 767, settings: { slidesToShow: 1 } },
    ],
  };
  return (
    <div className="about-page">
      <header className="header style7">
        <Topbar />
      </header>
      <div className="main-content main-content-about">
        <div className="container">
          <div className="row pt-4 pb-2">
            <div className="col-lg-12">
              <div className="breadcrumb-trail breadcrumbs">
                <ul className="trail-items breadcrumb">
                  <li className="trail-item trail-begin">
                    <a href="/" className=" text-decoration-none">Home</a>
                  </li>
                  <li className="trail-item trail-end active">About Us</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="content-area content-about col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div className="site-main">
                <h3 className="py-3">About Us</h3>
                <div className="page-main-content">
                  <div className="header-banner banner-image">
                    <div className="banner-wrap">
                      <div className="banner-header">
                        <div className="col-lg-5 col-md-offset-7">
                          <div className="content-inner">
                            <h2 className="title">
                              New Collection <br /> for you
                            </h2>
                            <div className="sub-title">
                              Shop the latest products right <br />
                              We have beard supplies from top brands.
                            </div>
                            <a href="#" className="ysera-button button">
                              Shop now
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-3 col-md-4 col-sm-4">
                      <div className="ysera-iconbox  layout1">
                        <div className="iconbox-inner">
                          <div className="icon-item">
                            <span className="placeholder-text">01</span>
                            <span className="icon flaticon-rocket-ship"></span>
                          </div>
                          <div className="content">
                            <h4 className="title">EU Free Delivery</h4>
                            <div className="text">
                              Free Delivery on all order from EU with price more
                              than $90.00
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-4 col-lg-offset-1">
                      <div className="ysera-iconbox  layout1">
                        <div className="iconbox-inner">
                          <div className="icon-item">
                            <span className="placeholder-text">02</span>
                            <span className="icon flaticon-return"></span>
                          </div>
                          <div className="content">
                            <h4 className="title">Money Guarantee</h4>
                            <div className="text">
                              30 Days money back guarantee no question asked!
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-4 col-lg-offset-1">
                      <div className="ysera-iconbox  layout1">
                        <div className="iconbox-inner">
                          <div className="icon-item">
                            <span className="placeholder-text">03</span>
                            <span className="icon flaticon-padlock"></span>
                          </div>
                          <div className="content">
                            <h4 className="title">Online Support 24/7</h4>
                            <div className="text">
                              We’re here to support to you 24/7. Let’s shopping
                              now!
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="team-member">
                    <div className="row">
                      <div className="col-sm-12 border-custom">
                        <span></span>
                      </div>
                    </div>
                    <h2 className="custom_blog_title center">
                      UniqueJeweller's Important Persons
                    </h2>
                    <Slider {...settings}>
                      <div className="team-member-item">
                        <div
                          className="member_avatar"
                          style={{ height: "350px", width: "350px" }}
                        >
                          <img
                            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQi9Vy0XUGZrvGS3IVpOYsFDKzSWxBSfSU0RQ&s"
                            alt="img"
                            className="rounded-circle mx-auto"
                            style={{ height: "100%", width: "100%" }}
                          />
                        </div>
                        <h5 className="member_name fs-2 text-center mt-4">
                          Mr Claudio
                        </h5>
                        <div className="member_position fs-2 text-center">
                          {" "}
                          CEO & Founder Ysera Outfit
                        </div>
                      </div>
                      <div className="team-member-item">
                        <div
                          className="member_avatar"
                          style={{ height: "350px", width: "350px" }}
                        >
                          <img
                            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTnY7iL6mQAG0nLvRithaRQc9DBbT7qhtQvnQ&s"
                            alt="img"
                            className="rounded-circle mx-auto"
                            style={{ height: "100%", width: "100%" }}
                          />
                        </div>
                        <h5 className="member_name fs-2 text-center mt-4">
                          Ms Julia
                        </h5>
                        <div className="member_position fs-2 text-center">
                          Marketing Head
                        </div>
                      </div>
                      <div className="team-member-item">
                        <div
                          className="member_avatar"
                          style={{ height: "350px", width: "350px" }}
                        >
                          <img
                            src="https://www.pngitem.com/pimgs/m/404-4042710_circle-profile-picture-png-transparent-png.png"
                            alt="img"
                            className="rounded-circle mx-auto"
                            style={{ height: "100%", width: "100%" }}
                          />
                        </div>
                        <h5 className="member_name fs-2 text-center mt-4">
                          Mr Steve
                        </h5>
                        <div className="member_position fs-2 text-center">
                          Designer
                        </div>
                      </div>
                      <div className="team-member-item">
                        <div
                          className="member_avatar"
                          style={{ height: "350px", width: "350px" }}
                        >
                          <img
                            src="https://media.istockphoto.com/id/1320811419/photo/head-shot-portrait-of-confident-successful-smiling-indian-businesswoman.jpg?s=612x612&w=0&k=20&c=bCUTB8vd8MnzZFIq-x645-SmLNk2sQzOvOvWCPGDfZ4="
                            alt="img"
                            className="rounded-circle mx-auto"
                            style={{ height: "100%", width: "100%" }}
                          />
                        </div>
                        <h5 className="member_name fs-2 text-center mt-4">
                          Ms Clara
                        </h5>
                        <div className="member_position fs-2 text-center">
                          Developer
                        </div>
                      </div>
                    </Slider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
        <div className="footer-device-mobile">
          <div className="wapper">
            <div className="footer-device-mobile-item device-home">
              <Link to="/" className="text-decoration-none">
                <span className="icon">
                  <i className="ph ph-house"></i>
                </span>{" "}
                Home
              </Link>
            </div>
            <div className="footer-device-mobile-item device-home device-cart">
              <Link to="/wishlist" className="text-decoration-none">
                <span className="icon">
                  <i className="ph ph-heart"></i>
                  <span className="count-icon">{wishlist.length}</span>
                </span>{" "}
                Wishlist
              </Link>
            </div>
            <div className="footer-device-mobile-item device-home device-cart">
              <Link to="/shopping-cart" className="text-decoration-none">
                <span className="icon">
                  <i className="ph ph-shopping-cart-simple" />
                  <span className="count-icon">{cart.length}</span>
                </span>{" "}
                Cart
              </Link>
            </div>
            <div className="footer-device-mobile-item device-home device-user">
              <Link to="/profile" className="text-decoration-none">
                <span className="icon">
                  <i className="ph ph-user"></i>
                </span>{" "}
                Account
              </Link>
            </div>
          </div>
        </div>
      </div>

      <Link to="#" className="backtotop">
        <i
          className="ph ph-caret-double-up"
          style={{
            color: "white",
            fontSize: "30px",
          }}
        ></i>
      </Link>
    </div>
  );
};

export default AboutPage;
